import React from 'react';
import { ArrowRightIcon, BriefcaseIcon, FlagIcon, MegaphoneIcon, UsersIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { participationOptions } from '../../data/news';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  users: UsersIcon,
  megaphone: MegaphoneIcon,
  flag: FlagIcon,
  briefcase: BriefcaseIcon
};
export function JoinMovement() {
  return <section aria-labelledby="join-heading" className="bg-white py-16 sm:py-20 lg:py-28" data-id="element-190" data-mp="38f1uskb89qs4">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-191" data-mp="3de4ya0bk7oxz">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-192" data-mp="3icg84b1utzg7">
          <Reveal className="lg:col-span-5" data-id="element-193" data-mp="3naregbsxxrto">
            <div className="overflow-hidden rounded-media" data-id="element-194" data-mp="3n9gc8gf58s4o">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/ebf27f4b-fec1-4388-bbbb-126b7ec20001.jpg" alt="Campaign volunteers organising materials at a community centre" loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-195" data-mp="1nxvo80lcy7xv" />
            </div>
          </Reveal>

          <div className="lg:col-span-7" data-id="element-196" data-mp="2pmna90v7gz85">
            <Reveal data-id="element-197" data-mp="2pnf4o8d2gqwu">
              <p className="flex items-center gap-2.5 text-[13px] font-semibold text-green-700" data-id="element-198" data-mp="2pmx0mpk5x8ed">
                <span aria-hidden className="h-px w-6 bg-current opacity-60" data-id="element-199" data-mp="2kpdn5rvagznh" />
                Get involved
              </p>
              <h2 id="join-heading" className="mt-3 max-w-[20ch] font-display text-[30px] leading-[1.1] tracking-[-0.02em] text-ink sm:text-[38px] lg:text-[42px]" data-id="element-200" data-mp="3i8ygar1kzscc">
                There is a place for you in this movement.
              </h2>
              <p className="mt-4 max-w-xl text-[17px] leading-relaxed text-slate-600" data-id="element-201" data-mp="34dmgi58kjbok">
                Whether you have two hours a week or two days, there is work here that matches
                your skills and your ward.
              </p>
            </Reveal>

            <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-202" data-mp="1uev2pkxd644q">
              {participationOptions.map((option, index) => {
              const Icon = icons[option.icon];
              return <li key={option.title} data-id="element-203" data-mp="1kekmdrg18glc" data-mpi={index}>
                    <Reveal delay={index * 0.04} data-id="element-204" data-mp="1khqap4gu7eg0">
                      <a href="/join" className="group flex h-full items-start gap-3.5 rounded-card border border-sand-200 p-5 transition-[border-color,background-color] duration-200 ease-emphasis hover:border-green-200 hover:bg-sand-50" data-id="element-205" data-mp="1pdfczfk8r9g0">
                        <Icon className="mt-0.5 h-5 w-5 shrink-0 text-green-600" data-id="element-206" data-mp="11qfpn3xslvw1" />
                        <span data-id="element-207" data-mp="16p0op01b69iw">
                          <span className="block text-[15px] font-semibold text-ink" data-id="element-208" data-mp="16o8x00au0vxw">
                            {option.title}
                          </span>
                          <span className="mt-1 block text-[14px] leading-relaxed text-slate-600" data-id="element-209" data-mp="woqbhff9x23q">
                            {option.description}
                          </span>
                        </span>
                      </a>
                    </Reveal>
                  </li>;
            })}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-4" data-id="element-210" data-mp="n3h1bhu8fhlj">
              <Button size="lg" data-id="element-211" data-mp="i21hft3sjh4q">
                Get involved
                <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-212" data-mp="x03j1xr9hsjc" />
              </Button>
              <Button variant="tertiary" data-id="element-213" data-mp="s1ii1w46r4tu">
                Explore all ways to participate
                <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-214" data-mp="15snll9aoch9g" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}